module.exports = __webpack_public_path__ + "static/img/bar2.f0d41d65.jpg";